<template>
  <section class="section2-container">
    <div class="content-container">
      <div class="pc-container logo-container">
        <p class="title1">
          {{ $t("home.s2.t3") }}
        </p>
        <div class="logo-box">
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/ethgray.svg">
            <img class="ishover" src="../../../../assets/home/hoverETH.svg">
            <div class="blockName">
              Ethereum
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/hoverOR.svg">
            <div class="blockName">
              Bnbchain
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/sol.svg">
            <div class="blockName">
              Solana
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/pol.svg">
            <div class="blockName">
              Polygon
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/ava.svg">
            <div class="blockName">
              Avalanche
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/tez.svg">
            <div class="blockName">
              Tezos
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/alggray.svg">
            <img class="ishover" src="../../../../assets/home/alg.svg">
            <div class="blockName">
              Algorand
            </div>
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/hoverC.svg">
            <img class="ishover" src="../../../../assets/home/c.svg">
            <div class="blockName">
              ATOM
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/hoverATM.svg">
            <div class="blockName">
              arbitrum
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="opt" src="../../../../assets/home/hoverOPT.svg">
            <div class="blockName">
              Optimism
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/near.svg">
            <div class="blockName">
              Near
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/aptgray.svg">
            <img class="ishover" src="../../../../assets/home/hoverAPT.svg">
            <div class="blockName">
              Aptos
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/sui.svg">
            <img class="ishover" src="../../../../assets/home/hoverSUI.svg">
            <div class="blockName">
              SUI
            </div>
          </div>
        </div>
      </div>

      <div class="m-container logo-container">
        <p class="title1">
          {{ $t("home.s2.t3") }}
        </p>
        <div class="logo-box">
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/ethgray.svg">
            <img class="ishover" src="../../../../assets/home/hoverETH.svg">
            <div class="blockName">
              Ethereum
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/hoverOR.svg">
            <div class="blockName">
              Bnbchain
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/sol.svg">
            <div class="blockName">
              Solana
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/pol.svg">
            <div class="blockName">
              Polygon
            </div>
          </div>
        </div>

        <div class="logo-box">
          <div class="logo-wrapper">
            <img src="../../../../assets/home/ava.svg">
            <div class="blockName">
              Avalanche
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/tez.svg">
            <div class="blockName">
              Tezos
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/alggray.svg">
            <img class="ishover" src="../../../../assets/home/alg.svg">
            <div class="blockName">
              Algorand
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/hoverC.svg">
            <img class="ishover" src="../../../../assets/home/c.svg">
            <div class="blockName">
              ATOM
            </div>
          </div>
        </div>

        <div class="logo-box">
          <div class="logo-wrapper">
            <img src="../../../../assets/home/hoverATM.svg">
            <div class="blockName">
              arbitrum
            </div>
          </div>
          <div class="logo-wrapper">
            <img src="../../../../assets/home/near.svg">
            <div class="blockName">
              Near
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/aptgray.svg">
            <img class="ishover" src="../../../../assets/home/hoverAPT.svg">
            <div class="blockName">
              Aptos
            </div>
          </div>
          <div class="logo-wrapper">
            <img class="isgary" src="../../../../assets/home/sui.svg">
            <img class="ishover" src="../../../../assets/home/hoverSUI.svg">
            <div class="blockName">
              SUI
            </div>
          </div>
        </div>
        <div class="logo-box">
          <div class="logo-wrapper">
            <img class="opt" src="../../../../assets/home/hoverOPT.svg">
            <div class="blockName">
              Optimism
            </div>
          </div>
        </div>
      </div>


      <Stake />

      <!-- <div class="section2-panel-container">
        <Panel
          :img-src="panel1.imgSrc"
          :title="panel1.title"
          :list="panel1.list"
        />
        <Panel
          :img-src="panel2.imgSrc"
          :title="panel2.title"
          :list="panel2.list"
        />
        <Panel
          :img-src="panel3.imgSrc"
          :title="panel3.title"
          :list="panel3.list"
        />
      </div> -->
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    panel1 () {
      const value = {
        imgSrc: require("../../../../assets/home/section2-img1.png"),
        title: this.$t("home.s2.panel.p1.t"),
        list: [
          this.$t("home.s2.panel.p1.l1"),
          this.$t("home.s2.panel.p1.l2"),
          this.$t("home.s2.panel.p1.l3")
        ]
      };
      return value;
    },
    panel2 () {
      const value = {
        imgSrc: require("../../../../assets/home/section2-img2.png"),
        title: this.$t("home.s2.panel.p2.t"),
        list: [
          this.$t("home.s2.panel.p2.l1"),
          this.$t("home.s2.panel.p2.l2"),
          this.$t("home.s2.panel.p2.l3")
        ]
      };
      return value;
    },
    panel3 () {
      const value = {
        imgSrc: require("../../../../assets/home/section2-img3.png"),
        title: this.$t("home.s2.panel.p3.t"),
        list: [
          this.$t("home.s2.panel.p3.l1"),
          this.$t("home.s2.panel.p3.l2"),
          this.$t("home.s2.panel.p3.l3")
        ]
      };
      return value;
    }
  },
  components: {
    // Panel: () => import("./Panel.vue")
    Stake: () => import("./Stake.vue")
  }
};
</script>

<style lang="less" scoped>
.section2-container {
  padding-top: 340px;
  position: relative;

  .logo-container {
    width: 90vw;
    position: absolute;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 10px 10px 0px rgba(111, 153, 223, 0.07), 0px 0px 33px 0px rgba(151, 154, 194, 0.29);

    p {
      margin-bottom: 20px;
    }

    .logo-box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 24px 0;

      .logo-wrapper {
        height: 100%;
        position: relative;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        -webkit-transition: -webkit-filter 200ms ease;
        transition: -webkit-filter 200ms ease;
        transition: filter 200ms ease;
        transition: filter 200ms ease, -webkit-filter 200ms ease;

        img {
          width: 50px;
        }

        .ishover {
          display: none;
        }

        .opt {
          width: 150px;
        }
      }

      .logo-wrapper:hover {
        -webkit-filter: none;
        filter: none;

        .ishover {
          display: inline-block;
        }

        .isgary {
          display: none;
        }
      }

      .c-logos-block__logo-img.is--active {
        -webkit-filter: none;
        filter: none;
      }
    }
  }

  .section2-panel-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}


@media (max-width: 500px) {
  .title1 {
    text-align: center;
    font-size: 18px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 600;
    color: #262626;
    line-height: 25px;
  }

  .pc-container {
    display: none;
  }

  .m-container {
    display: block;
  }

  .logo-container {
    top: -120px;
    left: 50%;
    margin-left: -45vw;
    height: 450px;
    padding: 20px 0;

    p {
      margin-bottom: 20px;
    }

    .logo-box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 24px 0;

      .logo-wrapper {
        height: 100%;
        position: relative;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        -webkit-transition: -webkit-filter 200ms ease;
        transition: -webkit-filter 200ms ease;
        transition: filter 200ms ease;
        transition: filter 200ms ease, -webkit-filter 200ms ease;

        img {
          width: 50px;
        }

        .ishover {
          display: none;
        }

        .opt {
          width: 150px;
        }
        .blockName {
          display: none;
          position: absolute;
          top: -35px;
          right: -35px;
          text-align: center;
          font-size: 16px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 600;
          color: #333;
          line-height: 20px;
          padding: 5px;
          background: #ddd;
          border-radius: 10px;
        }
      }

      .logo-wrapper:hover {
        -webkit-filter: none;
        filter: none;

        .ishover {
          display: inline-block;
        }

        .isgary {
          display: none;
        }
        .blockName{
          display: block;
        }
      }

      .c-logos-block__logo-img.is--active {
        -webkit-filter: none;
        filter: none;
      }
    }
  }

  .section2-panel-container {
    flex-wrap: wrap;
  }
}

@media (min-width: 501px) {

  .pc-container {
    display: block;
  }

  .m-container {
    display: none;
  }

  .logo-container {
    top: -80px;
    left: 50%;
    margin-left: -45vw;
    height: 320px;
    padding: 20px 0;

    p {
      margin-bottom: 20px;
    }

    .logo-box {
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 24px 0;

      .logo-wrapper {
        height: 100%;
        position: relative;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
        -webkit-transition: -webkit-filter 200ms ease;
        transition: -webkit-filter 200ms ease;
        transition: filter 200ms ease;
        transition: filter 200ms ease, -webkit-filter 200ms ease;

        img {
          width: 50px;
        }

        .ishover {
          display: none;
        }

        .opt {
          width: 150px;
        }

        .blockName {
          display: none;
          position: absolute;
          top: -35px;
          right: -40px;
          text-align: center;
          font-size: 16px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 600;
          color: #333;
          line-height: 20px;
          padding: 5px;
          background: #ddd;
          border-radius: 10px;
        }
      }

      .logo-wrapper:hover {
        -webkit-filter: none;
        filter: none;

        .ishover {
          display: inline-block;
        }

        .isgary {
          display: none;
        }
        .blockName{
          display: block;
        }
      }

      .c-logos-block__logo-img.is--active {
        -webkit-filter: none;
        filter: none;
      }
    }
  }

  .title1 {
    text-align: center;
    font-size: 34px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 600;
    color: #262626;
    line-height: 48px;
  }
}
</style>
